import { bytesToNDigits } from '@mail/cross-sizes-utils';
import { useSelector } from 'react-redux';
import { BASEQUOTA } from 'reactApp/appHelpers/configHelpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';

export function useUserQuota() {
    const totalQuota = useSelector(UserQuotaSelectors.getTotalOrBase);
    const baseQuota: number = useSelector(UserSelectors.getBasicSpace) || BASEQUOTA;
    const userQuota = totalQuota - baseQuota;
    return bytesToNDigits(userQuota, 3).value;
}
